import React, { useState, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import "./Authentication.css";
import { Link } from "react-router-dom";
import Button from "../../components/button/Button";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import UseAlert from "../../components/alert/UseAlert";
import { AppContext } from "../../context/AppContext";
import { rest_api_url } from "../../constants/urls";
import AuthLayout from "./AuthLayout";
import { ICONS } from "../../constants/icons";
import { normalizeEmail } from "../../hooks/General";

const Login = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });
  const [alert, alert_notify] = UseAlert();
  const context = useContext(AppContext);
  const setIsLoginPage = context.setIsLoginPage;

  // ### Handlers
  const handleSubmit = (e) => {
    try {
      e.preventDefault();
      setLoadingStatus(true);
      if (!loginData.email) {
        alert_notify("error", "Please enter email");
        setLoadingStatus(false);
        return false;
      }
      if (!loginData.password) {
        alert_notify("error", "Please enter password");
        setLoadingStatus(false);
        return false;
      }
      let data = {
        ...loginData,
        email: normalizeEmail(loginData.email),
      };
      setLoginData({
        ...loginData,
        button_content: <Spinner animation="border" role="status" className="spinner"></Spinner>,
        button_icon: "",
      });
      axios
        .post(rest_api_url.login, data)
        .then((response) => {
          if (response.status === 200) {
            setLoadingStatus(false);
            var data = response.data;
            var session_key = response.data.session;
            localStorage.setItem("email", normalizeEmail(loginData.email));
            sessionStorage.setItem("session_key", session_key);
            // If user needs to give new password
            if (data.challenge_name === "NEW_PASSWORD_REQUIRED") {
              alert_notify("success", "Please enter your new password");
              setLoadingStatus(false);
              props.history.push("/new_password");
            } else if (data.challenge_name === "SOFTWARE_TOKEN_MFA") {
              setLoadingStatus(false);
              props.history.push("/mfa_signin");
            } else {
              const mfa_setup_required = data.mfa_setup_required;
              localStorage.setItem("access_token", data.access_token);
              localStorage.setItem("refresh_token", data.refresh_token);
              if (mfa_setup_required) {
                setTimeout(() => {
                  props.history.push("/mfa_setup");
                }, 100);
              } else {
                localStorage.removeItem("selectedClients");
                props.history.push("/transaction-list");
              }
              setLoadingStatus(false);
              setIsLoginPage(false);
            }
          }
        })
        .catch((err) => {
          if (err?.response?.status === 404) {
            alert_notify("error", "Endpoint not found");
          } else if (err?.response?.data?.error?.data === "PasswordResetRequiredException") {
            localStorage.setItem("email", normalizeEmail(loginData.email));
            props.history.push("/new_password?type=reset");
          } else if (err.response.data.error.code === 1134) {
            props.history.push("/account_blocked");
          } else {
            setLoadingStatus(false);
            alert_notify("error", err?.response.data.error.message);
            setLoginData({
              ...loginData,
              button_content: "Login",
              button_icon: "",
            });
          }
        });
    } catch (e) {
      alert_notify("error", e?.message);
    }
  };
  const handlerEmailInput = (e) => {
    setLoginData({
      ...loginData,
      email: normalizeEmail(e.target.value),
    });
  };
  const handlerPasswordInput = (e) => {
    setLoginData({
      ...loginData,
      password: e.target.value,
    });
  };

  return (
    <>
      <AuthLayout
        className="login-form-body"
        // loginLink="/forgot_password"
        // linkText="Forgot password?"
        alert={alert}
      >
        <div className="login-messages">
          <span className="login-welcome">Welcome back!</span>
          <span className="login-text-v2">Sign in to your company account</span>
        </div>
        <div className="form-container">
          <form id="login_form" onSubmit={(e) => handleSubmit(e)}>
            {/* Email */}
            <Row>
              <Col className="login-col">
                <label className="login-label">Email</label>
                <div className="position-relative">
                  <input
                    type="text"
                    className="login-input"
                    autoComplete="off"
                    value={loginData.email}
                    onChange={(e) => {
                      handlerEmailInput(e);
                    }}
                    onKeyUp={(e) => {
                      handlerEmailInput(e);
                    }}
                  />
                </div>
              </Col>
            </Row>
            {/* Password */}
            <Row>
              <Col className="login-col login-password">
                <label className="login-label">Password</label>
                <div className="position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="login-input"
                    autoComplete="off"
                    value={loginData.password}
                    onChange={(e) => {
                      handlerPasswordInput(e);
                    }}
                  />
                  <span className="show-password" onClick={(e) => setShowPassword(!showPassword)}>
                    <img src={ICONS.eye} alt="eye" />
                  </span>
                </div>
              </Col>
            </Row>
            <Row className="">
              <Col className="login-col d-flex align-items-center justify-content-end">
                <div className="forget-password">
                  <Link to="/forgot_password">Forgot password?</Link>
                </div>
              </Col>
            </Row>

            {/* Login Button */}
            <Row>
              <Col className="d-flex">
                <Button className="primary btn_login mobile-btn">
                  {!loadingStatus ? "Sign in" : <Spinner animation="border" role="status" className="spinner" />}
                </Button>
              </Col>
            </Row>
          </form>
        </div>
      </AuthLayout>
    </>
  );
};

export default Login;
